/**!
 * Created by Leonardo Cheslacki on 28/10/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Compiler -- min-resources=app
 */
module.exports.path = {
    uri_css: 'css',
    uri_js: 'js',
    uri_img: 'img',
    uri_media: 'media',
    uri_xml: 'xml',
    uri_src: 'src',
    uri_cover: 'capa/capa'
};

module.exports.iframe = {
    size: {
        width: 1920,
        height: 1000,
    },
    attributes: {
        allowfullscreen: '0',
        scrolling: 'no',
        frameborder: '0'
    }
};

module.exports.audio = {
    loop: true,
    all: true
};

module.exports.video = {
    menu_play: true,
    current_time: 0,
    thumbnail_time: 5
};

module.exports.api = {
    ajax_setup_headers: {
        'Authorization': 'Bearer 10|XQ9Fp64YNrPE1I73zEpGdxjy1ZaZHXL6a895fRoZ'
    },
    url: 'http://gerenciador.local/api'
};

module.exports.external = {
    size: {
        width: 800,
        height: 600
    },
    attributes: {
        toolbar: '0',
        location: '0',
        menubar: '0'
    }
};

module.exports.keyboard = {
    delay: 100,
    form: 'auth',
    focus: null,
    submit: false,
    ignore_keys: ['Backspace', 'Space', 'CapsLock', 'ShiftLeft', 'ShiftRight', 'Com', 'Tab', 'Enter'],
    upper_accent_keys: ['key_6', 'key_BracketLeft', 'key_Quote'],
    down_accent_keys: ['key_BracketLeft', 'key_Quote'],
    accent_keys: ['´´', '~~', '¨¨', '``', '^^', '~e', '~i', '~u', '~E', '~I', '~U']
};

module.exports.orientation = {
    speed: 2,
    slide: {
        color_title: '0x000000',
        color_line: '0x000000',
        color_arrow: '0x000000',
        color_round: '0x000000',
        color_circle: '0x774A2D'
    },
    hours: {
        start: 6,
        end: 18
    },
    stations: [
        {
            month: 1,
            day: null
        },
        {
            month: 2,
            day: null
        },
        {
            month: 3,
            day: 20
        },
        {
            month: 4,
            day: null
        },
        {
            month: 5,
            day: null
        },
        {
            month: 6,
            day: 20
        },
        {
            month: 7,
            day: null
        },
        {
            month: 8,
            day: null
        },
        {
            month: 9,
            day: 22
        },
        {
            month: 10,
            day: null
        },
        {
            month: 11,
            day: null
        },
        {
            month: 12,
            day: 21
        }
    ],
    degrees: {
        autumn: 5,
        winter: 11,
        spring: 5,
        summer: 0
    }
};

module.exports.select = {
    friction: 0.8,
    text: {
        text_x: 140,
        text_y: 45,
        color_enabled: '0x333333',
        color_disabled: '0xAABBC0',
        font_size: 25,
        capitalize: false
    }
};

module.exports.implantation = {
    pin: {
        number_x: null,
        number_y: -7.2,
        color_enabled: '0x000000',
        color_disabled: '0xCCCCCC',
        color_round: '0x774A2D'
    },
    text: {
        text_x: 140,
        text_y: 42,
        color_number: '0xFFFFFF',
        color_text: '0x392A17',
        font_size: 14,
        capitalize: true,
        upper_case: true,
        font_color_same: false
    },
    modal: {
        scale: 0.7,
        composition_name: 'capa',
        padding_vertical: 10,
        padding_horizontal: 7,
        color_text: '0xFFFFFF',
        color_symbol: '0x000000'
    }
};

module.exports.gallery = {
    /**
     * https://github.com/Splidejs/splide
     */
    options: {
        type: 'loop',
        focus: 'center',
        pagination: false,
        perPage: 1,
        arrows: false,
        // legal_warn: 'perspectiva ilustrada'
        // autoplay: true
    },
    buttons: {
        svgLeft: {
            attributes: {
                class: 'gallery-arrow-icon',
                viewBox: '0 0 16000 16000'
            },
            content: [
                {
                    polyline: {
                        attributes: {
                            points: '11040, 1920 4960, 8000 11040, 14080'
                        }
                    }
                }
            ]
        },
        svgRight: {
            attributes: {
                class: 'gallery-arrow-icon',
                viewBox: '0 0 16000 16000'
            },
            content: [
                {
                    polyline: {
                        attributes: {
                            points: '4960, 1920 11040, 8000 4960, 14080'
                        }
                    }
                }
            ]
        },
        // svgLeft: {
        //     attributes: {
        //         class: 'gallery-arrow-icon',
        //         viewBox: '0 0 512 512'
        //     },
        //     content: [
        //         {
        //             g: {
        //                 attributes: {
        //                     transform: 'translate(106.26851,104.16471)'
        //                 },
        //                 content: [
        //                     {
        //                         path: {
        //                             attributes: {
        //                                 style: 'fill:#b3aba7;stroke:none',
        //                                 d: 'm -106.18863,404.05352 h 508 v -343.693759 -88.9 c 0,-16.86328 1.83116,-34.40297 -7.26276,-49.47708 -8.07642,-13.38743 -21.70753,-22.885841 -37.18724,-25.287701 -8.63907,-1.34045 -17.7305,-0.64146 -26.45833,-0.64146 H 292.00929 10.757214 -34.221956 c -9.75051,0 -20.01385,-0.88696 -29.63333,0.91541 -13.72523,2.57168 -25.9166,10.781581 -33.68926,22.367921 -10.158424,15.14268 -8.644084,32.646 -8.644084,50.00625 V 56.391011 404.05352 M 380.38012,382.62227 H -85.286536 V 59.036851 -27.217319 c 0,-12.66654 -2.62846,-28.35263 4.1286,-39.6875 1.4101,-2.36542 3.19144,-4.40887 5.13181,-6.35 3.2689,-3.27015 6.78418,-6.0642 11.1125,-7.81764 7.89477,-3.19826 17.33536,-1.97194 25.66459,-1.97194 h 57.41458 264.847916 52.12291 c 12.3197,0 24.53255,-1.15907 34.39584,7.71803 2.08711,1.87841 3.95444,3.99475 5.5495,6.30488 7.746,11.21863 5.29841,26.23661 5.29841,39.15834 v 84.93125 327.554169 m -247.65,-106.3625 h 0.26459 l 14.55208,-14.55209 V 261.4431 L 79.813464,193.70977 58.117624,172.01393 47.005124,160.63685 H 274.81137 V 139.47018 H 47.005124 l 10.84792,-11.1125 21.43125,-21.43125 68.262496,-67.997919 c -2.95739,-4.19835 -7.48031,-7.7449 -11.1125,-11.37708 -0.82208,-0.82207 -2.63456,-3.41613 -3.96875,-3.08353 -0.92191,0.22983 -1.74035,1.38457 -2.38125,2.0252 l -5.29167,5.29166 -19.84375,19.84375 c -19.836106,19.8361 -39.959666,39.43051 -59.795826,59.266669 -9.65976,9.65978 -21.79381,18.75428 -24.00441,33.07292 -1.22354,7.92521 -0.12055,16.59482 4.01592,23.54792 2.34293,3.93832 5.67312,6.85129 8.87599,10.05416 l 13.49375,13.49375 z'
        //                             }
        //                         }
        //                     }
        //                 ]
        //             }
        //         }
        //     ]
        // },
        // svgRight: {
        //     attributes: {
        //         class: 'gallery-arrow-icon',
        //         viewBox: '0 0 512 512'
        //     },
        //     content: [
        //         {
        //             g: {
        //                 attributes: {
        //                     transform: 'translate(106.26851,104.16471)'
        //                 },
        //                 content: [
        //                     {
        //                         path: {
        //                             attributes: {
        //                                 style: 'fill:#b3aba7;stroke:none',
        //                                 transform: 'rotate(180, 149.73149, 151.83529)',
        //                                 d: 'm -106.18863,404.05352 h 508 v -343.693759 -88.9 c 0,-16.86328 1.83116,-34.40297 -7.26276,-49.47708 -8.07642,-13.38743 -21.70753,-22.885841 -37.18724,-25.287701 -8.63907,-1.34045 -17.7305,-0.64146 -26.45833,-0.64146 H 292.00929 10.757214 -34.221956 c -9.75051,0 -20.01385,-0.88696 -29.63333,0.91541 -13.72523,2.57168 -25.9166,10.781581 -33.68926,22.367921 -10.158424,15.14268 -8.644084,32.646 -8.644084,50.00625 V 56.391011 404.05352 M 380.38012,382.62227 H -85.286536 V 59.036851 -27.217319 c 0,-12.66654 -2.62846,-28.35263 4.1286,-39.6875 1.4101,-2.36542 3.19144,-4.40887 5.13181,-6.35 3.2689,-3.27015 6.78418,-6.0642 11.1125,-7.81764 7.89477,-3.19826 17.33536,-1.97194 25.66459,-1.97194 h 57.41458 264.847916 52.12291 c 12.3197,0 24.53255,-1.15907 34.39584,7.71803 2.08711,1.87841 3.95444,3.99475 5.5495,6.30488 7.746,11.21863 5.29841,26.23661 5.29841,39.15834 v 84.93125 327.554169 m -247.65,-106.3625 h 0.26459 l 14.55208,-14.55209 V 261.4431 L 79.813464,193.70977 58.117624,172.01393 47.005124,160.63685 H 274.81137 V 139.47018 H 47.005124 l 10.84792,-11.1125 21.43125,-21.43125 68.262496,-67.997919 c -2.95739,-4.19835 -7.48031,-7.7449 -11.1125,-11.37708 -0.82208,-0.82207 -2.63456,-3.41613 -3.96875,-3.08353 -0.92191,0.22983 -1.74035,1.38457 -2.38125,2.0252 l -5.29167,5.29166 -19.84375,19.84375 c -19.836106,19.8361 -39.959666,39.43051 -59.795826,59.266669 -9.65976,9.65978 -21.79381,18.75428 -24.00441,33.07292 -1.22354,7.92521 -0.12055,16.59482 4.01592,23.54792 2.34293,3.93832 5.67312,6.85129 8.87599,10.05416 l 13.49375,13.49375 z'
        //                             }
        //                         }
        //                     }
        //                 ]
        //             }
        //         }
        //     ]
        // }
    },
    styles: {
        zoomFullscreen: {
            zoomBackground: {
                backgroundColor: '#FFFFFF',
                maxWidth: '100vw',
                maxHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 auto',
                position: 'absolute',
                left: '0',
                right: '0',
                top: '0',
                bottom: '0',
                zIndex: '1000'
            },
            zoomImg: {
                maxWidth: '100vw',
                maxHeight: '100vh'
            }
        },
        zoomButton: {
            zoomIcon: {
                width: '30px',
                height: '30px'
            },
            zoomButton: {
                cursor: 'pointer',
                position: 'absolute',
                bottom: '-45px',
                right: '-45px',
                padding: '10px'
            }
        }
    }
};

module.exports._360 = {
    speed: 6,
    slide: {
        color_title: '0xFFFFFF',
        color_line: '0xFFFFFF',
        color_arrow: '0xFFFFFF',
        color_round: '0xFFFFFF',
        color_circle: '0x000000'
    }
};

module.exports.map = {
    // Regular attributes.
    has_selection: false,
    show_distance: true,
    pixels_by_meter: 4.9,
    should_be_fixed_route: false, // Makes a fixed and unchangeable path; this flag is prioritized over fixed_start.
    should_be_fixed_start: false, // Flag for fixed starting point (so only destiny can be selected).
    final_marker_icon_direction: 'left',
    final_marker_plus_bottom: -10,
    line_color: '#F0855C',
    head_color: '#FF0000',
    line_thickness: 5,
    line_dash_speed: 50,
    dash_segments: [3, 9], // [0] is dash size, [1] is dash space interval; unit for both is px.
    qrcode_origin_url: null,
    qrcode_size: 120,
    qrcode_top: '770px',
    qrcode_right: '1680px',
    map_layers: [
        // 'example',
    ],
    select_groups: { // Used to set the same color on items at the same group.
        // example: {color: '#FF432E'},
        // example2: {label: 'name', color: '#7EB9E4'},
    },
    // Attributes for testing.
    show_map_tool: false,
    location_test_color: 'rgba(11, 156, 19, 0.4)',
    location_test_border_color: 'green',
    show_nodes: true,
    node_adding_color: '#2EB774', // light green.
    node_color: 'cyan',
    node_border_color: 'blue',
    node_size: 4,
    show_locations: true,
    color_location: '',
};

module.exports.scroll = {
    friction: 0.8,
    pin: {
        number_x: null,
        number_y: -7.2,
        color_enabled: '0x000000',
        color_disabled: '0xCCCCCC',
        color_round: '0xFFFFFF'
    },
    text: {
        text_x: 140,
        text_y: 34,
        color_number: '0xFFFFFF',
        color_text: '0xFFFFFF',
        font_size: 16,
        capitalize: false
    },
    modal: {
        scale: 0.7,
        composition_name: 'capa'
    },
    content_text: {
        frame_01: {
            A: 32
        }
    }
};

module.exports.view = {
    frame: 1,
    pav: 1,
    text: {
        color_text: '0xFFFFFF',
        font_size: 18,
        text_x: null,
        text_y: 5
    }
};

module.exports.offline = {
    name_cache: 'web-application-offline-v1',
    name_warn: 'warn-web-application-offline-v1'
};

/**
 * Compiler -- min-resources=main
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch', "1 or 2".
 * @param dom_containers Array containers resize, 'elements'.
 */
module.exports.make = {
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: false,
    scale_type: 1
};
